import _createForOfIteratorHelper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { Plugin } from 'ckeditor5/src/core.js';
import ImageUtils from '../imageutils.js';
/**
 * The image caption utilities plugin.
 */
var ImageCaptionUtils = /*#__PURE__*/function (_Plugin) {
  _inherits(ImageCaptionUtils, _Plugin);
  var _super = _createSuper(ImageCaptionUtils);
  function ImageCaptionUtils() {
    _classCallCheck(this, ImageCaptionUtils);
    return _super.apply(this, arguments);
  }
  _createClass(ImageCaptionUtils, [{
    key: "getCaptionFromImageModelElement",
    value:
    /**
     * Returns the caption model element from a given image element. Returns `null` if no caption is found.
     */
    function getCaptionFromImageModelElement(imageModelElement) {
      var _iterator = _createForOfIteratorHelper(imageModelElement.getChildren()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;
          if (!!node && node.is('element', 'caption')) {
            return node;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    }
    /**
     * Returns the caption model element for a model selection. Returns `null` if the selection has no caption element ancestor.
     */
  }, {
    key: "getCaptionFromModelSelection",
    value: function getCaptionFromModelSelection(selection) {
      var imageUtils = this.editor.plugins.get('ImageUtils');
      var captionElement = selection.getFirstPosition().findAncestor('caption');
      if (!captionElement) {
        return null;
      }
      if (imageUtils.isBlockImage(captionElement.parent)) {
        return captionElement;
      }
      return null;
    }
    /**
     * {@link module:engine/view/matcher~Matcher} pattern. Checks if a given element is a `<figcaption>` element that is placed
     * inside the image `<figure>` element.
     * @returns Returns the object accepted by {@link module:engine/view/matcher~Matcher} or `null` if the element
     * cannot be matched.
     */
  }, {
    key: "matchImageCaptionViewElement",
    value: function matchImageCaptionViewElement(element) {
      var imageUtils = this.editor.plugins.get('ImageUtils');
      // Convert only captions for images.
      if (element.name == 'figcaption' && imageUtils.isBlockImageView(element.parent)) {
        return {
          name: true
        };
      }
      return null;
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'ImageCaptionUtils';
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "requires",
    get: function get() {
      return [ImageUtils];
    }
  }]);
  return ImageCaptionUtils;
}(Plugin);
export { ImageCaptionUtils as default };